import {usePermissions} from './usePermissions'

export const useProductEnabled = () => {
  const {data, isLoading} = usePermissions()

  const {productEnabled: enabled} = data || {}

  return {enabled, isLoading}
}
